import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

const MobCreditComp = ({metaName, payload, delay, showKeys = true}) => {
    const [keys, setKeys] = useState(null);
    const [values, setValues] = useState(null);

    useEffect(() => {
        if(payload){

            let tmpKeys = [];
            let tmpVals = [];
            for (const [key, val] of Object.entries(payload)) {
                if(key == 'runTime') continue;
                let tmpKey = key.replace("_", " ")
                let tmpVal = val;
                try{
                    if(!Array.isArray(val))
                        val.replace("_", " ")
                }catch{}
                tmpKeys.push(tmpKey);
                tmpVals.push(tmpVal)
            }
              
            setKeys(tmpKeys)
            setValues(tmpVals);
        }
    }, [])

    return(
        <motion.div
            initial={{
                opacity: 0
            }}animate={{
                opacity: 1,
                transition: {
                    duration: 0.55,
                    delay: delay,
                    ease: "easeIn"
                }
            }}exit={{
                opacity: 0
            }}
        >
            {showKeys &&
            <div className="mob_ss_title">
                {metaName &&
                    <span>{metaName}</span>
                }
            </div>
            }
            <div className="mob_ss_content">
                {showKeys &&
                    <div className="mob__keys">
                        {keys && keys.map((key, idx) => (
                            <span>{key}</span>
                        ))}
                    </div>
                }
                <div className={`mob__values`}
                    style={{
                        paddingTop: !showKeys ? "6dvh" : "",
                    }}
                >
                    {values && values.map((val, idx) => (
                        Array.isArray(val) ?
                        val.map((vitem, vidx) => (
                            <span
                                style={{
                                    paddingBottom: idx == 0 && !showKeys ? "4px" : null
                                }}
                            >{vitem ? vitem : " "}</span>
                        )) :
                        <span
                            style={{
                                paddingBottom: idx == 0 && !showKeys ? "4px" : null
                            }}
                        >{val ? val : " "}</span>
                    ))}
                </div>
            </div>
        </motion.div>
    )
}

export default MobCreditComp;